module.exports = __webpack_public_path__ + "img/topics2.46e807f9.png";